

































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TrackingRegisterService from "@/services/TrackingRegister";
import {
  PenunjangTracking,
  StatusFarmasiTracking,
  StatusKasirTracking,
  StatusPenunjangTracking,
  StatusPoliTracking,
  TrackingRegister
} from "@/types/tracking_register";

type Tampilan = { teks: string; warna: string };

@Component
export default class TrackingRegisterDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: [String, Number], default: null }) readonly registerId!:
    | string
    | number
    | null;
  @Prop({ type: String, default: "" }) readonly nama!: string;

  tracking: TrackingRegister | null = null;
  memuat = false;
  galat = "";
  permintaan = 0;

  readonly STATUS_POLI: Record<StatusPoliTracking, Tampilan> = {
    MENUNGGU: { teks: "Menunggu", warna: "grey" },
    DIPERIKSA: { teks: "Diperiksa", warna: "success" },
    BATAL: { teks: "Batal", warna: "error" }
  };

  readonly STATUS_PENUNJANG: Record<StatusPenunjangTracking, Tampilan> = {
    TIDAK_ADA: { teks: "Tidak ada order", warna: "grey" },
    MENUNGGU: { teks: "Menunggu hasil", warna: "warning" },
    SELESAI: { teks: "Hasil tersedia", warna: "success" }
  };

  readonly STATUS_FARMASI: Record<StatusFarmasiTracking, Tampilan> = {
    TIDAK_ADA: { teks: "Tidak ada resep", warna: "grey" },
    BELUM_DIKIRIM: { teks: "Resep belum dikirim", warna: "orange" },
    MENUNGGU: { teks: "Menunggu farmasi", warna: "warning" },
    DIKERJAKAN: { teks: "Dikerjakan", warna: "blue" },
    SELESAI: { teks: "Siap diserahkan", warna: "teal" },
    DISERAHKAN: { teks: "Obat diserahkan", warna: "success" }
  };

  readonly STATUS_KASIR: Record<StatusKasirTracking, Tampilan> = {
    BELUM: { teks: "Belum ada pembayaran", warna: "grey" },
    DIBAYAR: { teks: "Sudah dibayar", warna: "success" },
    FINAL: { teks: "Final kasir", warna: "success" },
    DITUTUP: { teks: "Register ditutup", warna: "indigo" }
  };

  get daftarPenunjang(): Array<{
    kunci: string;
    judul: string;
    ikon: string;
    isi: PenunjangTracking;
  }> {
    if (!this.tracking) {
      return [];
    }
    return [
      {
        kunci: "lab",
        judul: "Laboratorium",
        ikon: "mdi-microscope",
        isi: this.tracking.lab
      },
      {
        kunci: "radiologi",
        judul: "Radiologi",
        ikon: "mdi-desktop-mac",
        isi: this.tracking.radiologi
      }
    ];
  }

  @Watch("value", { immediate: true })
  onBuka(terbuka: boolean): void {
    if (terbuka && this.registerId) {
      this.muat();
    }
  }

  @Watch("registerId")
  onGantiRegister(): void {
    this.tracking = null;
    this.galat = "";
    if (this.value && this.registerId) {
      this.muat();
    }
  }

  waktu(nilai: string | null): string {
    if (!nilai) {
      return "-";
    }
    const jam = nilai.substring(11, 16).replace(":", ".");
    if (this.tracking && nilai.substring(0, 10) === this.tracking.tanggal) {
      return jam;
    }
    return `${nilai.substring(8, 10)}/${nilai.substring(5, 7)} ${jam}`;
  }

  async muat(): Promise<void> {
    if (!this.registerId) {
      return;
    }
    const nomor = ++this.permintaan;
    const register = this.registerId;
    this.memuat = true;
    this.galat = "";
    try {
      const hasil = await TrackingRegisterService.getByRegister(register);
      if (nomor === this.permintaan && register === this.registerId) {
        this.tracking = hasil;
      }
    } catch (e) {
      if (nomor === this.permintaan) {
        this.galat = "Tracking pasien belum bisa dimuat. Coba muat ulang.";
      }
    } finally {
      if (nomor === this.permintaan) {
        this.memuat = false;
      }
    }
  }
}
